var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.8138,
    y: 9.24135,
    width: 39,
    height: 73,
    rx: 7.5,
    transform: "rotate(11 35.8138 9.24135)",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0964 50.0313C44.7594 50.2799 45.3438 50.6739 45.8171 51.1691C45.8795 50.6676 45.9587 50.1614 46.0549 49.6503C45.4474 49.9135 44.7805 50.049 44.0964 50.0313ZM48.2866 43.2009C47.6445 42.0227 46.5005 41.1313 45.0991 40.8589C42.6004 40.3732 40.1561 42.0052 39.6682 44.5151C39.2277 46.7814 40.5158 48.9631 42.59 49.7385C40.3762 49.6816 38.3636 51.2268 37.9258 53.4788C37.4348 56.0047 39.0914 58.4256 41.5901 58.9113C43.2446 59.2329 44.8889 58.6237 45.9472 57.4303C46.2358 59.0584 46.7287 60.6306 47.4214 62.1501L48.0622 63.5558L57.6474 65.4189L55.0505 60.0302C54.6869 59.2758 54.3442 57.9391 54.2051 56.2232C54.0695 54.5488 54.1462 52.7363 54.4592 51.1261C54.7713 49.5205 55.3786 47.8133 56.1315 46.3124C56.903 44.7744 57.7216 43.6633 58.3414 43.0999L62.7679 39.0764L53.1827 37.2132L52.0619 38.2765C50.5405 39.7199 49.28 41.3586 48.2866 43.2009Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9049 47.0028C44.7788 47.1727 45.6471 46.6009 45.8201 45.711C45.9899 44.8371 45.4006 43.9737 44.5267 43.8038C43.6448 43.6324 42.7829 44.2137 42.613 45.0876C42.4401 45.9775 43.0229 46.8314 43.9049 47.0028ZM42.1625 55.9664C43.0364 56.1363 43.9047 55.5645 44.0777 54.6746C44.2476 53.8007 43.6583 52.9373 42.7843 52.7674C41.9024 52.596 41.0406 53.1773 40.8707 54.0512C40.6977 54.9412 41.2806 55.795 42.1625 55.9664Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0289 50.0706C48.2465 54.0954 48.6695 57.6556 50.1511 60.9057L52.3479 61.3327C51.1799 58.909 50.7725 54.3701 51.5143 50.5537C52.2546 46.7454 54.3326 42.6895 56.3235 40.8799L54.1267 40.4529C51.5354 42.9113 49.8097 46.0538 49.0289 50.0706Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 20C84 28.8366 76.8365 36 68 36C59.1634 36 52 28.8366 52 20C52 11.1634 59.1634 4 68 4C76.8365 4 84 11.1634 84 20Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 33C75.1797 33 81 27.1797 81 20C81 12.8203 75.1797 7 68 7C60.8203 7 55 12.8203 55 20C55 27.1797 60.8203 33 68 33Z",
    fill: "#737373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.615 13.5H69.3849L69.1633 22.0565H66.8366L66.615 13.5ZM68 27.054C67.1598 27.054 66.495 26.4169 66.495 25.6044C66.495 24.7919 67.1598 24.1548 68 24.1548C68.8402 24.1548 69.5049 24.7919 69.5049 25.6044C69.5049 26.4169 68.8402 27.054 68 27.054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralError);
export default __webpack_public_path__ + "static/media/general-error.277bf820805053bf60567e5e12c70166.svg";
export { ForwardRef as ReactComponent };